import makeValidationSchema from './FaxCoverSheetMakeValidationSchema'
import { useTranslation } from 'cng-web-lib'
import React, { useEffect } from 'react'
import Namespace from 'src/constants/locale/Namespace'
import ManifestKeys from 'src/constants/locale/key/AciHighwayManifest'
import { Card, Grid } from '@material-ui/core'
import { components, constants } from 'cng-web-lib'
import { useFormContext,useWatch } from "react-hook-form";
import Alert from '../../../components/Alert'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FileForUserGetUserDetails } from 'src/common/FileForUserCommon'
import ACIHighwayManifestTranslationText from './../contexts/ACIHighwayManifestTranslationText'

const {
  card: {
    CngSimpleCardHeader,
  },
  form: {
    field: {
      CngTextField,
    },
  },
  CngGridItem,
} = components

const {
  filter: {EQUAL}
} = constants

const DEFAULT_INITIAL_VALUES = Object.freeze({
  fax: "",
  subject: "",
  message: "",
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({
  disabled,
  showNotification,
  shouldHideMap,
  tripNo
}) {
  const { setValue } = useFormContext();
  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()  

  useEffect(() => {
    setValue("subject", tripNo)
  }, [tripNo]);

  useWatch("fileForUserId");
  useWatch("fileForUserLoginId")
  useWatch("fileForUserPartyId");
  useEffect(() => {
    let fileForUserDetails = FileForUserGetUserDetails();
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      setValue("fileForUserId", fileForUserDetails.fileForUserId)
      setValue("fileForUserLoginId", fileForUserDetails.fileForUserLoginId)
      setValue("fileForUserPartyId", fileForUserDetails.fileForUserPartyId)
    }
  }, []);

	return (
    <Card>
      <Grid container spacing={2}>
        <CngGridItem xs={12} sm={12} shouldHide={shouldHideMap.fax}>
          <CngTextField
            required
            name="fax"
            label={aciHighwayManifestTranslationText.fax}
            disabled={disabled}
            helperText={aciHighwayManifestTranslationText.faxHelpText}
            size='small'
            inputProps={{ maxLength: 11 }}
          />
        </CngGridItem>
        <CngGridItem xs={12} sm={12} shouldHide={shouldHideMap.emailSubject}>
          <CngTextField
            name="subject"
            label={aciHighwayManifestTranslationText.emailSubject}
            disabled={disabled}
            size='small'
          />
        </CngGridItem>
        <CngGridItem xs={12} sm={12} shouldHide={shouldHideMap.emailMessage}>
          <CngTextField
            multiline
            rows={4}
            variant="outlined"
            inputProps={{ maxLength: 100 }}
            name="message"
            label={aciHighwayManifestTranslationText.emailMessage}
            disabled={disabled}
            onChange={(e) => { setValue('message', e.target.value.replace(/(\r\n|\r|\n)+/g, ' ')) }}
          />
        </CngGridItem>
      </Grid>
      <Grid item xs={12} sm={12}>
        <Alert
          severity='warning'
          icon={<FontAwesomeIcon icon={['fal', 'info-circle']} />}
        >
          <strong>{aciHighwayManifestTranslationText.note}:</strong> {aciHighwayManifestTranslationText.faxRemark}
        </Alert>
      </Grid>
    </Card>
	)
}

const FaxCoverSheetFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default FaxCoverSheetFormProperties
